import React from 'react';
import ReactDOM from 'react-dom/client';
import {
    EventType,
    PublicClientApplication,
    Configuration,
    RedirectRequest,
} from '@azure/msal-browser';
import 'flatpickr/dist/themes/material_red.css';
import './src/resources/css/sitestyles.css';
import 'react-toastify/dist/ReactToastify.css';
import ActionMemoApp from './src/js/components/ActionMemoApp';

declare global {
    interface Window {
        msalConfig: Configuration;
        actionMemoApiRequest: RedirectRequest;
        actionMemoApiUrl: string;
        nintendoIpSet: string;
        tableauDashboardUrl: string;
    }
}

const { msalConfig } = window;

export const msalInstance = new PublicClientApplication(msalConfig);

const accounts = msalInstance.getAllAccounts();

if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event) => {
    if (
        event.eventType === EventType.LOGIN_SUCCESS &&
        event.payload &&
        'account' in event.payload &&
        event.payload.account
    ) {
        const { account } = event.payload;
        msalInstance.setActiveAccount(account);
    }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<ActionMemoApp msalInstance={msalInstance} />);
